// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__28-qG","col":"styles_col__1KG_J"};